import {
  Activity,
  ListTodo,
  Webhook,
  AlertTriangle,
  ArrowLeftRight,
  BadgePercent,
  BarChart3,
  Bell,
  BookOpen,
  Boxes,
  Briefcase,
  Cable,
  CreditCard,
  Database,
  FileCheck2,
  FileSearch,
  FileText,
  FolderOpen,
  Gavel,
  Globe,
  Inbox,
  LayoutDashboard,
  Layers,
  ListOrdered,
  Lock,
  type LucideIcon,
  MailQuestion,
  Network,
  Receipt,
  RefreshCcw,
  ScrollText,
  Server,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  Siren,
  Tags,
  Target,
  Timer,
  Users,
  UserSquare2,
  Wallet,
  Waypoints,
  Workflow,
  Contact,
  Repeat,
  UserCog,
  KeyRound,
  ClipboardCheck,
  History,
  CalendarClock,
  ShieldHalf,
  Settings2,
  Scale,
  Plug,
  Waypoints as Route,
  Landmark,
  FilePen,
  ListChecks,
  PenLine,
  Settings,
  Puzzle,
  Calculator,
  Radar,
  Crosshair,
  Coins,
  CalendarPlus,
  Handshake,
  LayoutGrid,
} from 'lucide-react';

/** Icon per nav leaf path (and per section id), shown in the sidebar and the command menu. */
export const NAV_ICONS: Readonly<Record<string, LucideIcon>> = {
  business: Briefcase,
  compliance: ShieldCheck,
  registry: Network,
  ops: Activity,
  admin: Settings2,
  settings: Plug,
  '/settings/registries': Cable,
  '/settings/tlds': Route,
  '/settings/vnnic': Landmark,
  '/contacts': Contact,
  '/transfers': Repeat,
  '/registrant-changes': UserCog,
  '/name-changes': FilePen,
  '/settings/name-change-requirements': ListChecks,
  '/compliance/work': ListTodo,
  '/settings/webhooks': Webhook,
  '/compliance/policies': Scale,
  '/compliance/deadlines': CalendarClock,
  '/admin/staff': Users,
  '/admin/roles': ShieldHalf,
  '/admin/approvals': ClipboardCheck,
  '/admin/api-credentials': KeyRound,
  '/admin/audit': History,
  '/domains': Globe,
  '/customers': Users,
  '/subjects': UserSquare2,
  '/dossiers': FolderOpen,
  '/documents': FileText,
  '/quotes': FileCheck2,
  '/orders': ShoppingCart,
  '/billing': CreditCard,
  '/ledger': Wallet,
  '/payments': ArrowLeftRight,
  '/invoices': Receipt,
  '/pricing': Tags,
  '/promotions': BadgePercent,
  '/auctions': Gavel,
  '/backorders': Target,
  '/compliance/vnnic/dossier-sync': RefreshCcw,
  '/compliance/vnnic/international-reports': ScrollText,
  '/compliance/vnnic/coverage': Layers,
  '/compliance/vnnic/corrections': FileSearch,
  '/compliance/vnnic/post-operations': ListChecks,
  '/compliance/vnnic/registrar-signature': PenLine,
  '/compliance/vnnic/tracking-reports': BarChart3,
  '/compliance/icann/rdap': Database,
  '/compliance/icann/rde': Boxes,
  '/compliance/icann/disclosure': MailQuestion,
  '/compliance/icann/abuse': ShieldAlert,
  '/compliance/icann/disputes': Gavel,
  '/compliance/cases': Inbox,
  '/compliance/legal-locks': Lock,
  '/registry/registries': Server,
  '/registry/tlds': Globe,
  '/registry/epp': Cable,
  '/registry/sessions': Waypoints,
  '/registry/transactions': ListOrdered,
  '/registry/poll': Bell,
  '/registry/reconciliation': RefreshCcw,
  '/ops/overview': LayoutDashboard,
  '/ops/services': Server,
  '/ops/registries': Network,
  '/ops/queues': Layers,
  '/ops/workflows': Workflow,
  '/ops/metrics': BarChart3,
  '/ops/logs': BookOpen,
  '/ops/traces': Waypoints,
  '/ops/alerts': AlertTriangle,
  '/ops/incidents': Siren,
  '/ops/slo': Timer,
};

/** Sidebar icon of each hub (`nav/hubs.ts`). */
export const HUB_ICONS: Readonly<Record<string, LucideIcon>> = {
  home: ListTodo,
  domains: Globe,
  customers: Users,
  sales: Receipt,
  products: Tags,
  compliance: ShieldCheck,
  ops: Activity,
  settings: Settings,
  backorder: Target,
  auctions: Gavel,
};

/** Sidebar entry icons (`nav/modules.ts`), after the reference layouts. */
export const ENTRY_ICONS: Readonly<Record<string, LucideIcon>> = {
  home: LayoutDashboard,
  domains: Globe,
  dossiers: FolderOpen,
  subjects: UserSquare2,
  customers: Users,
  orders: ShoppingCart,
  invoices: Receipt,
  ledger: Wallet,
  products: Tags,
  registry: Server,
  compliance: ShieldCheck,
  ops: Activity,
  settings: Settings,
  addons: Puzzle,
  quote: Calculator,
  backorder: LayoutDashboard,
  drops: Radar,
  backorders: ListOrdered,
  catching: Crosshair,
  holds: Coins,
  auctions: Gavel,
  auctionSessions: CalendarPlus,
  bids: ScrollText,
  settlement: Scale,
  handover: Handshake,
};

/** Module icons ("Không gian quản lý", `nav/modules.ts`). */
export const MODULE_ICONS: Readonly<Record<string, LucideIcon>> = {
  platform: LayoutGrid,
  domains: Globe,
  backorder: Target,
  auctions: Gavel,
};
